import { LOCALE_ID, NgModule } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';
registerLocaleData(localeAr);
import { CommonModule } from '@angular/common';

import { environment } from 'src/environments/environment';
import { EmptyStateComponent } from './empty-state/empty-state.component';

// Helpers
import { MaterialModule } from 'src/app/helpers/material-modules';
import { DndDirective } from 'src/app/helpers/dnd.directive';
import { SanitizeHtmlPipePipe } from 'src/app/helpers/sanitize-html-pipe.pipe';
import { ShortNamePipe } from 'src/app/helpers/short-name.pipe';
import { PrintDirective } from 'src/app/helpers/print.directive';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecaptchaModule, RecaptchaSettings, RECAPTCHA_LANGUAGE, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { TranslateModule } from '@ngx-translate/core';
import { DropDownDirective } from '../helpers/drop-down.directive';
import { LottieModule } from 'ngx-lottie';
import player from 'lottie-web';
import { TreeSelectionComponent } from './tree-selection/tree-selection.component';
import { SideSheetComponent } from './side-sheet/side-sheet.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { OnlynumberDirective } from '../helpers/onlynumber.directive';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomPaginator } from '../helpers/CustomPaginatorConfiguration';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { IslamicPickerComponent } from './datepicker/islamic-picker/islamic-picker.component';
import { NgxHijriGregorianDatepickerModule } from 'ngx-hijri-gregorian-datepicker';
import { DateModelPipe } from '../helpers/DateModelTime.pipe';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { DirtyCheckGuard } from '../helpers/CanDeactivate/dirty-check.guard';
import { LightgalleryModule } from 'lightgallery/angular';
import { FileManagerComponent } from './file-manager/file-manager.component';
import { InView } from '../helpers/in-view.directive';
import { PhoneNumberComponent } from './phone-number/phone-number.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgSelectFormFieldControlDirective } from '../helpers/ng-select.directive';
import { PagingComponent } from './paging/paging.component';
import { VideoManagerComponent } from './video-manager/video-manager.component';
import { PhotoManagerComponent } from './photo-manager/photo-manager.component';
import { TagsSelectorSearchComponent } from './tags-selector-search/tags-selector-search.component';
import { RestaurantsDropdownComponent } from './restaurants-dropdown/restaurants-dropdown.component';
import { FloorViewerComponent } from '../features/reservations/components/floor-viewer/floor-viewer.component';
import { ServersComponent } from '../features/reservations/components/servers/servers.component';
import { WastedMenuItemFormComponent } from './wasted-menu-item-form/wasted-menu-item-form.component';
import { PaymentDetailsComponent } from './check-out/payment-details/payment-details.component';

import { CheckOutComponent } from 'src/app/shared/check-out/check-out.component';
import { NumKeypadComponent } from 'src/app/shared/num-keypad/num-keypad.component';
import { PaymentConfirmationComponent } from 'src/app/shared/check-out/payment-confirmation/payment-confirmation.component';
import { PricesDetailsComponent } from 'src/app/shared/check-out/prices-details/prices-details.component';
import { PaidListComponent } from './check-out/paid-list/paid-list.component';
import { ReceiptComponent } from './receipt/receipt.component';
import { ReservationDetailsComponent } from '../features/reservations/components/details/reservation.details.component';

import { RouterModule } from '@angular/router';
import { SafePipe } from '../helpers/SafePipe';
import { TimeAgoPipe } from '../helpers/time-ago.pipe';
import { AllFloorsViewerComponent } from '../features/reservations/components/all-floors-viewer/all-floors-viewer.component';
import { ImageControlComponent } from './image-control/image-control.component';
import { CropperDialogComponent } from './image-control/cropper-dialog/cropper-dialog.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { CartGuestFormComponent } from '../features/place-order/components/cart-guest-form/cart-guest-form.component';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule } from '@angular-material-components/datetime-picker';
import { AutoResizeDirective } from '../helpers/auto-resize.directive';

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    // Directives
    DndDirective,
    PrintDirective,
    OnlynumberDirective,
    InView,
    NgSelectFormFieldControlDirective,
    AutoResizeDirective,

    // Pipes
    ShortNamePipe,
    // FilterPipe,
    // DateTimeMergePipe,
    DropDownDirective,
    DateModelPipe,
    TimeAgoPipe,

    //Components
    EmptyStateComponent,
    TreeSelectionComponent,
    SideSheetComponent,
    DatepickerComponent,
    IslamicPickerComponent,
    FileManagerComponent,
    VideoManagerComponent,
    PhotoManagerComponent,
    PhoneNumberComponent,
    PagingComponent,
    TagsSelectorSearchComponent,
    RestaurantsDropdownComponent,
    FloorViewerComponent,
    AllFloorsViewerComponent,
    ServersComponent,
    WastedMenuItemFormComponent,
    ReservationDetailsComponent,

    //checkout
    CheckOutComponent,
    NumKeypadComponent,
    PaymentConfirmationComponent,
    PaymentDetailsComponent,
    PricesDetailsComponent,
    PaidListComponent,
    ReceiptComponent,
    ImageControlComponent,
    CropperDialogComponent,
    CartGuestFormComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    InfiniteScrollModule,
    TranslateModule.forChild({}),
    ReactiveFormsModule,
    FormsModule,
    RecaptchaModule,
    LottieModule.forRoot({ player: playerFactory }),
    NgxIntlTelInputModule,
    NgbModule,
    NgxHijriGregorianDatepickerModule,
    NgxMaterialTimepickerModule,
    LightgalleryModule,
    NgSelectModule,
    RouterModule,
    SanitizeHtmlPipePipe,
    SafePipe,
    ImageCropperModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule
  ],
  exports: [
    MaterialModule,
    SanitizeHtmlPipePipe,
    DndDirective,
    ShortNamePipe,
    PrintDirective,
    AutoResizeDirective,
    // FilterPipe,
    // DateTimeMergePipe,
    DropDownDirective,
    DateModelPipe,
    TimeAgoPipe,
    SafePipe,
    OnlynumberDirective,
    InView,
    InfiniteScrollModule,
    EmptyStateComponent,
    TreeSelectionComponent,
    SideSheetComponent,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    RecaptchaModule,
    LottieModule,
    NgxIntlTelInputModule,
    NgbModule,
    DatepickerComponent,
    IslamicPickerComponent,
    NgxHijriGregorianDatepickerModule,
    NgxMaterialTimepickerModule,
    LightgalleryModule,
    FileManagerComponent,
    VideoManagerComponent,
    PhotoManagerComponent,
    PhoneNumberComponent,
    NgSelectModule,
    NgSelectFormFieldControlDirective,
    PagingComponent,
    TagsSelectorSearchComponent,
    RestaurantsDropdownComponent,
    FloorViewerComponent,
    AllFloorsViewerComponent,
    ServersComponent,
    WastedMenuItemFormComponent,

    ReservationDetailsComponent,
    RouterModule,
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,

    //checkout
    CheckOutComponent,
    NumKeypadComponent,
    PaymentConfirmationComponent,
    PaymentDetailsComponent,
    PricesDetailsComponent,
    PaidListComponent,
    ReceiptComponent,
    ImageControlComponent,
    CropperDialogComponent,
    CartGuestFormComponent,
  ],
  providers: [
    DirtyCheckGuard,
    // {provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {duration: 3000}},
    { provide: MatPaginatorIntl, useValue: CustomPaginator() },
    // { provide: NgxMatDateAdapter, useClass: CustomNgxMatDateAdapter },
    // { provide: NGX_MAT_DATE_FORMATS, useValue: APP_NGX_MAT_DATE_FORMATS }, // Use this instead of MAT_DATE_FORMATS
    { provide: LOCALE_ID, useValue: localStorage.getItem('language') || 'en' },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: environment.googleSiteKey,
        useValue: localStorage.getItem('language') || 'en'
      } as RecaptchaSettings,
    },
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.googleSiteKey } as RecaptchaSettings,
    },
    {
      provide: RECAPTCHA_LANGUAGE,
      useFactory: (locale: string) => locale,
      deps: [LOCALE_ID],
    }
  ]
})
export class SharedModule { }
